<script lang="ts" setup>
const props = defineProps({
  label: {
    type: String,
    default: "File Name",
  },
  existingText: {
    type: String,
    default: "",
  },
  okButtonLabel: {
    type: String,
    default: "Save",
  },
  cancelButtonLabel: {
    type: String,
    default: "Cancel",
  },
});

defineEmits(["confirm", "cancel"]);

const name = ref(props.existingText ?? "");
</script>

<template>
  <div class="w-[500px]">
    <h1 class="text-h4">{{ label }}</h1>
    <BaseTextInput
      v-model="name"
      placeholder="Enter a name"
      class="my-4 w-full"
      @keyup.enter="$emit('confirm', name)"
    />

    <div class="flex flex-row justify-end w-full">
      <BaseTextButton
        @click="$emit('cancel')"
        color="danger"
        class="min-w-[80px]"
      >
        {{ cancelButtonLabel }}
      </BaseTextButton>
      <BaseButton
        class="h-[40px] ml-2 min-w-[80px]"
        @click="$emit('confirm', name)"
      >
        {{ okButtonLabel }}
      </BaseButton>
    </div>
  </div>
</template>

<style scoped></style>
